// ** Initial State
const initialState = {
  data: {},
  params: {},
  dashloading: false,
  customerRegister: [],
  depositFrequencyGraph: [],
  newcomerSummarize: null
}

const newcomerData = (state = initialState, action) => {
  switch (action.type) {
    case 'clear_newcomer_data':
      return {
        ...state,
        data: {},
        params: {},
        dashloading: false,
        customerRegister: [],
        newcomerSummarize: null
      }
    case 'NEWCOMER_CUSTOMER_REGISTER':
      return {
        ...state,
        customerRegister: action.data
      }
    case 'NEWCOMER_CUSTOMER_SUMMARIZE':
      return {
        ...state,
        newcomerSummarize: action.data
      }
    case 'NEWCOMER_DEPOSIT_FREQUENCY':
      return {
        ...state,
        depositFrequencyGraph: action.data
      }
    default:
      return { ...state }
  }
}

export { newcomerData }